<template>
  <div class="banner container">
    <div class="banner__container">
      <p class="font-weight-bold">New release on sale now!</p>
      <h1>
        MATTHEW <br class="d-md-none" />
        BOUNDS <br />
        COME FIX YOU A PLATE
      </h1>
      <Button
        class="mt-4"
        variant="secondary"
        size="sm"
        @click="handleCreatorsClick"
      >
        Buy Now
      </Button>
    </div>
    <img
      src="@/assets/main-banner-mobile-promo.png"
      alt="main-banner"
      class="banner__bg-image-mobile"
    />
  </div>
</template>

<script>
import Button from '@/components/Elements/Button';

export default {
  name: 'MainBanner',

  components: {
    Button
  },

  methods: {
    handleCreatorsClick() {
      this.$router.push('/creators/yourbarefootneighbor');
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  background-color: $primary-color;
  height: 355px;
  position: relative;
  background-image: url('assets/main-banner-promo.png');
  background-size: contain;
  background-position-x: right;
  background-position-y: bottom;
  background-repeat: no-repeat;

  &__bg-image {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
  }

  &__bg-image-mobile {
    display: none;
    position: absolute;
    right: 0;
    bottom: 0;
    height: 355px;
  }

  &__title-background {
    background-color: $dark-color;
    border-radius: 16px;
    height: 48px;
    position: relative;
    top: -4px;

    @media (max-width: $screen-width-md) {
      position: absolute;
      width: 355px;
      line-height: 48px;
      top: auto;
      left: -20px;
      bottom: -46px;
      padding-left: 17px !important;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    span {
      position: relative;
      top: 4px;
      color: $light-grey-color;
    }
  }

  &__container {
    display: flex;
    justify-content: center;
    height: 100%;
    flex-direction: column;
    width: 700px;
    padding-left: 100px;
    color: $dark-color;

    p,
    h1,
    div {
      z-index: 2;
    }

    h1 {
      position: relative;
      font-family: 'PPRader-Bold', sans-serif;
      font-size: 40px;
      line-height: 46px;
      text-transform: uppercase;
    }
  }

  @media (max-width: $screen-width-md) {
    background-image: none;

    &__bg-image-mobile {
      display: block;
    }

    &__bg-image {
      display: none;
    }

    &__container {
      width: 340px;
      padding: 0;

      &-br {
        display: none;
      }

      div {
        margin-top: 16px !important;
      }
    }
  }
}

.mac-os {
  .banner__title-background {
    span {
      top: 0;
    }
  }
}
</style>
